
<div class="d-flex justify-content-center p-2 busy-overlay-parent"
*ngIf="pathViewStore.vm$ | async as vm">

<div *ngIf="vm.testPoint" class="d-flex flex-row">        
<div class="px-2 text-nowrap">
    <button (click)="changeGuard(vm.testPoint, moveToFirst )" class="btn btn-secondary mr-sm-1" 
        [disabled]="!vm.hasPreviousTestPoint">
        <i class="fa fa-fast-backward"></i>
    </button>
    <button (click)="changeGuard(vm.testPoint, moveToPrevious)" class="btn btn-secondary" 
        [disabled]="!vm.hasPreviousTestPoint">
        <i class="fa fa-step-backward"></i>
    </button>
</div>
<div class="order-column px-1 d-flex flex-column" title="Testing order within path">            
    <div class="field-value">{{vm.testPoint?.order}}</div>
    <div class="field-name text-muted" >Order&nbsp;</div>
</div>
<div class="point-column px-1 flex-column text-nowrap" *ngIf="pathTest.type == 'path test'">
    <div class="d-flex flex-column">
        <div class="field-value">{{vm.testPoint?.pointId}}</div>
        <div class="field-name text-muted d-flex flex-row justify-content-start">
            <div>Point</div>
            <div class="pl-2">
            <button *ngIf="isSurvey" (click)="onRecordAssistance(assistanceModalTemplate)" 
                class="bottom-btn btn btn-secondary btn-sm">Record Assistance Data</button>
            <button *ngIf="!isSurvey" (click)="onLocate()" 
                class="bottom-btn btn btn-secondary btn-sm">Locate</button>
            &nbsp;
            <button (click)="copyPointId(vm.testPoint?.pointId)" 
            class="bottom-btn btn btn-secondary btn-sm">Copy</button>
        </div>
        </div>
    </div>
</div> 
<div class="px-2 text-nowrap">
    <button (click)="changeGuard(vm.testPoint, moveToNext )" class="btn btn-secondary mr-sm-1" [disabled]="!vm.hasNextTestPoint">
        <i class="fa fa-step-forward"></i>
    </button>
    <button (click)="changeGuard(vm.testPoint, moveToLast )" class="btn btn-secondary" [disabled]="!vm.hasNextTestPoint">
        <i class="fa fa-fast-forward"></i>
    </button>
</div>
</div>



<ng-template #assistanceModalTemplate>
<div class="modal-header">
    <div class="modal-title">Record Assistance Data</div>
    <button type="button" class="close pull-right" aria-label="Close" (click)="assistanceModal.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
TODO - enable assistance editor
<!-- 
<div class="modal-body"><app-assistance-editor [pointId]="selectedPointTest?.pointId" 
    [pathId]="selectedPointTest?.parentId"></app-assistance-editor></div>
    -->
<div class="modal-footer">
    <button>Save (TODO)</button>
    <button (click)="assistanceModal.hide()">Cancel</button>
</div>
</ng-template>




</div>